(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[18830],{

/***/ 66413:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vpnpricecomparison/listing/[listingSlug]",
      function () {
        return __webpack_require__(62445);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ VpnPriceComparisonListingPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_vpnpricecomparison_listingPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var __N_SSP = true;
function VpnPriceComparisonListingPage() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_vpnpricecomparison_listingPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        type: "listing"
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3294,30171,82546,90677,49774,92888,40179], function() { return __webpack_exec__(66413); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);